import defer from "promise-defer"

export const ALERT_OPEN = "ALERT_OPEN"

export const _openAlert = data => ({
  type: ALERT_OPEN,
  ...data,
  open: true,
})

export const ALERT_CLOSE = "ALERT_CLOSE"

export const _closeAlert = data => ({
  type: ALERT_CLOSE,
  open: false,
})

let alertDeferred = null

export const openAlert = data => {
  return dispatch => {
    alertDeferred = defer()
    dispatch(_openAlert(data))
    return alertDeferred.promise
  }
}

export const closeAlert = canceled => {
  return dispatch => {
    if (alertDeferred) {
      if (canceled) {
        alertDeferred.reject()
      } else {
        alertDeferred.resolve()
      }
      dispatch(_closeAlert())
      setTimeout(() => {
        alertDeferred = null
      }, 250)
    }
  }
}
